import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type HighlightsProps = {
  /** Additional class names for styling. */
  className?: string;
  /** The list of card properties to display. */
  cardProps: ComponentProps<typeof Card>[];
};

/**
 * More stories component that displays a grid of article cards for withHighlights template.
 * Figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=2096-14893&t=m7103yrVxON0jRlB-4
 */
const MoreStories = ({
  cardProps,
  className,
}: HighlightsProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  const otherVariant: CardVariations = {
    kicker: {
      color: cn("text-gray-515"),
      extraClass: cn("font-poppins text-4xs font-light leading-6"),
    },
    image: {
      position: "left",
      width: "w-full",
      aspectRatio: "aspect-3x2",
      orientation: "landscape",
      filters: { w: 960, h: 600, dpr: 1, f: "webp" },
      imageWrapperClass: cn("aspect-3x2"),
    },
    content: {
      width: "w-full",
      extraClass: "pt-4",
    },
    title: {
      size: "text-lg",
      color: "text-gray-850",
      extraClass: cn("font-bold font-lct"),
    },
  };

  return (
    <div
      data-testid="template-with-highlight-more-stories-component"
      className={className}
    >
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
        {cardProps.map((cardProp) => {
          return (
            <Card
              key={cardProp.id}
              {...cardProp}
              variations={otherVariant}
              className="block"
            />
          );
        })}
      </div>
    </div>
  );
};

export default MoreStories;
